import React from 'react';
import PracticeDetailPage from './PracticeDetailPage';

export default function PracticePharmaceuticals() {
  return (
    <PracticeDetailPage
      practiceId="pharmaceuticals"
      canonicalPath="/practice/pharmaceuticals"
    />
  );
}
